export default {"src":"/_next/static/media/pair-3.17678683.svg","height":505,"width":416,"blurWidth":0,"blurHeight":0};